import * as React from "react";
import { LimitAndClosureScreens } from "../components/LimitsAndClosure/LimitsAndClosure";
import {
    LimitsAndClosureDataType,
    LimitsAndClosureStreamProps
} from "../containers/LimitsAndClosureContainter/LimitsAndClosureContainer";

type LimitsAndClosureContextType = {
    updateHandler: (data: LimitsAndClosureStreamProps) => void;
    initialData: LimitsAndClosureStreamProps;
    children: React.ReactNode;
};

// tslint:disable:no-object-literal-type-assertion
export const LimitsAndClosureContext = React.createContext({
    editable: false,
    // @ts-ignore
    getData: (screen: string): LimitsAndClosureDataType => {
        return {} as LimitsAndClosureDataType;
    },

    // @ts-ignore
    getSavedData: (screen: string): LimitsAndClosureDataType => {
        return {} as LimitsAndClosureDataType;
    },

    getRawData: (
        // @ts-ignore
        key: keyof LimitsAndClosureStreamProps
    ): LimitsAndClosureDataType => {
        return {} as LimitsAndClosureDataType;
    },

    handleCancelClick: () => {
        return;
    },
    handleEditClick: () => {
        return;
    },
    handleSaveClick: () => {
        return;
    },
    // @ts-ignore
    setAmount: (amount: string) => {
        return;
    },
    // @ts-ignore
    setReason: (event: React.BaseSyntheticEvent) => {
        return;
    },
    // @ts-ignore
    setValidity: (event: React.BaseSyntheticEvent) => {
        return;
    }
});

// tslint:disable:object-literal-sort-keys
// tslint:disable:jsx-no-multiline-js
const LimitsAndClosureContextProvider = ({
    updateHandler,
    initialData,
    children
}: LimitsAndClosureContextType) => {
    const [editable, setEditState] = React.useState(false);
    const [activeScreen, setActiveScreen] = React.useState<string>();
    const {
        data,
        setData,
        temporaryData,
        setTemporaryData
    } = useStateWithCallBack(initialData, updateHandler);

    React.useEffect(() => {
        if (JSON.stringify(temporaryData) !== JSON.stringify(initialData)) {
            setTemporaryData(initialData);
        }
    }, [initialData]);

    const getData = (screen: string): LimitsAndClosureDataType => {
        setActiveScreen(screen);
        return temporaryData[mapScreenToKey(screen)];
    };

    const getRawData = (
        key: keyof LimitsAndClosureStreamProps
    ): LimitsAndClosureDataType => {
        return data[key];
    };

    const getSavedData = (screen: string): LimitsAndClosureDataType => {
        return data[mapScreenToKey(screen)];
    };

    const handleEditClick = () => {
        setEditState(true);
    };

    const handleSaveClick = () => {
        setData(temporaryData);
        setEditState(false);
    };

    const handleCancelClick = () => {
        setTemporaryData(data);
        setEditState(false);
    };

    const setValidity = (e: React.BaseSyntheticEvent) => {
        const id = e.target.id;
        if (id) {
            dataSetter(id, "validity");
        } else {
            const period = e.target.getAttribute("data-period");
            const index = e.target.getAttribute("data-index");
            dataSetter(index, "validity");
            dataSetter(period, "selectedValidityKey");
        }
    };

    const setAmount = (amount: string) => {
        dataSetter(amount, "amount");
    };

    const setReason = (e: React.BaseSyntheticEvent) => {
        const value = e.target.id;
        dataSetter(value, "reason");
    };

    const dataSetter = (value: string, param: string) => {
        const key = mapScreenToKey(activeScreen);
        setTemporaryData((prevState: any) => ({
            ...prevState,
            [key]: {
                ...prevState[key],
                updated: true,
                data: {
                    ...prevState[key].data,
                    [param]: value
                }
            }
        }));
    };

    return (
        <LimitsAndClosureContext.Provider
            value={{
                // @ts-ignore
                data,
                handleCancelClick,
                handleEditClick,
                handleSaveClick,
                editable,
                getData,
                getSavedData,
                setAmount,
                setReason,
                setValidity,
                getRawData
            }}
        >
            {children}
        </LimitsAndClosureContext.Provider>
    );
};

export const mapScreenToKey = (screen: any) => {
    switch (screen) {
        case LimitAndClosureScreens.lossLimit:
            return "LOSS";
        case LimitAndClosureScreens.payInLimit:
            return "PAYIN";
        case LimitAndClosureScreens.accountClosure:
            return "CLOSURE";
        case LimitAndClosureScreens.exclusion:
            return "EXCLUSION";
        default:
            throw Error();
    }
};

const useStateWithCallBack = (
    initialData: LimitsAndClosureStreamProps,
    callback: (data: LimitsAndClosureStreamProps) => void
) => {
    const [data, setData] = React.useState(initialData);
    const [temporaryData, setTemporaryData] = React.useState<
        LimitsAndClosureStreamProps
    >(initialData);

    // update data on change from ebet
    React.useEffect(() => {
        if (JSON.stringify(data) !== JSON.stringify(initialData)) {
            setData(initialData);
        }
    }, [initialData]);

    // update data on save
    React.useEffect(() => {
        if (JSON.stringify(data) !== JSON.stringify(initialData)) {
            callback(data);
        }
    }, [data]);

    return {
        data,
        temporaryData,
        setData,
        setTemporaryData
    };
};

export default LimitsAndClosureContextProvider;
